import React, { useEffect, useCallback } from 'react'
import {useDispatch, useSelector} from 'react-redux'
import { Flex, Box } from 'reflexbox'
import { Avatar, Name, Icon } from '../../healtheraComponents'
import Drawer from '@material-ui/core/Drawer'
import UserProfile from '../UserProfile/UserProfileContainer'
import * as authActions from '../../redux/authentication'

export default function UserAvatar() {

  const { profilePage, user: { forename, surname, avatar_url } = {} } = useSelector(state => state.authentication)
  const userName = forename + ' ' + surname
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(authActions.getUser())
  }, [dispatch])

  const handleClick = useCallback(() => {
    dispatch(authActions.showProfile())
  }, [dispatch])

  return (
    <>
      {forename && <Avatar>
        <Drawer open={profilePage}>
          <UserProfile name={userName}/>
        </Drawer>
        <Flex onClick={handleClick.bind(this)}>
          <Box>
            <Name variant='subtitle1' style={{lineHeight:'50px'}}>{userName}</Name>
          </Box>
          {avatar_url && <Box>
            <Icon 
              src={avatar_url} 
              borderRadius={`50%`} 
              width={`45px`} 
              margin={`0 0 0 15px`} 
              cursor={`pointer`} 
              alt='avatar'
            />
          </Box>}
        </Flex>
      </Avatar>}
    </>
  )
}
